import { MediaApiModels } from '@/tsClient/servers/noodleMedia';

const isMediaReadyEnough = (media: Pick<MediaApiModels.Media, 'id' | 'mediaStatus'> | null): boolean =>
  Boolean(
    media &&
    media.id &&
    media.mediaStatus !== MediaApiModels.MediaStatus.Uploading &&
    media.mediaStatus !== MediaApiModels.MediaStatus.Error,
  );

export default isMediaReadyEnough;
